// @ts-nocheck
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { apiCreateMatchV2, apiGetTypeMatchesGroupedByType } from "../../../api/matchApi";
import { apiListBeltsV2 } from "../../../api/beltApi";
import { apiListWrestlersV2 } from "../../../api/wrestlerApi";
import colors from "../../../styles/colors";

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    max-height: 95vh;
    overflow-y: auto;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 21px;
    font-weight: 500;
    color: gold;
`;

const PpvInfo = styled.div`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.8);
    font-style: italic;
    text-align: center;
    padding: 8px;
    background-color: ${colors.bgColorBlack};
    border-radius: 4px;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 25px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    
    &:hover {
        opacity: 0.75;
    }
    
    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div<{ mb?: string }>`
    margin-bottom: ${props => props.mb || '16px'};
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const FormTextarea = styled.textarea`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    resize: vertical;
    min-height: 60px;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const FormSelect = styled.select`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 17px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;
    
    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #0b5ed7;
        border-color: #0a58ca;
        box-shadow: 0 0 0 4px rgba(49, 132, 253, 0.5);
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
    
    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
        box-shadow: 0 0 0 4px rgba(130, 138, 145, 0.5);
    }
`;

const ErrorText = styled.p`
    margin-top: 4px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 15px;
`;

const GeneralErrorText = styled.div`
    margin-bottom: 16px;
    padding: 12px;
    background-color: rgba(220, 53, 69, 0.1);
    border: 1px solid #dc3545;
    border-radius: 4px;
    color: #dc3545;
    font-size: 15px;
`;

const StatusMessage = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #000000;
`;

const SuccessText = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #198754;
`;

const RadioGroup = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 8px;
`;

const RadioLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: 400;
    color: white;
    
    input[type="radio"] {
        width: auto;
        margin: 0;
        cursor: pointer;
    }
`;

const DropdownContainer = styled.div`
    position: relative;
    width: 100%;
`;

const DropdownInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    color: #000000;
    border-bottom: 1px solid #e9ecef;
    
    &:hover {
        background-color: #f8f9fa;
    }
    
    &:last-child {
        border-bottom: none;
    }
`;

const DropdownEmpty = styled.div`
    padding: 8px 12px;
    color: #6c757d;
    font-style: italic;
`;

const RemoveFileButton = styled.button`
    padding: 4px 12px;
    font-size: 13px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 8px;
    
    &:hover {
        background-color: #c82333;
    }
`;

const TeamSection = styled.div`
    margin-top: 15px;
    padding: 15px;
    background-color: ${colors.bgColorBlack};
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

const TeamTitle = styled.h4`
    font-size: 17px;
    font-weight: 600;
    color: gold;
    text-transform: uppercase;
    margin: 0 0 15px 0;
`;

const WrestlerSelectContainer = styled.div`
    position: relative;
    margin-bottom: 10px;
    width: 100%;
`;

const WrestlerSelectLabel = styled.label`
    display: block;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
`;

function CreateMatchModale({ ppvSpecific, ppvGeneraleName, typeMatchesList, onTypeMatchesLoad, beltsList, onBeltsLoad, wrestlersList, onWrestlersLoad, closeModalClick, onMatchCreated }: any) {
    const formRef = useRef<any>(null);
    const [responseApiCreateMatch, setResponseApiCreateMatch] = useState<any>({});
    const [errorsForm, setErrorsForm] = useState<any>({});
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [matchCreated, setMatchCreated] = useState(false);
    const [isFirstRendering, setIsFirstRendering] = useState(true);

    // Dropdown refs
    const typeMatchDropdownRef = useRef<any>(null);
    const stipulationDropdownRef = useRef<any>(null);
    const beltDropdownRef = useRef<any>(null);
    const wrestlerDropdownRefs = useRef<any>({});

    // Type Match state
    const [typeMatchTypeSearch, setTypeMatchTypeSearch] = useState('');
    const [selectedTypeMatchType, setSelectedTypeMatchType] = useState<any>(null);
    const [showTypeMatchTypeDropdown, setShowTypeMatchTypeDropdown] = useState(false);
    const [filteredTypeMatchTypes, setFilteredTypeMatchTypes] = useState<any[]>([]);

    // Stipulation state
    const [stipulationSearch, setStipulationSearch] = useState('');
    const [selectedStipulation, setSelectedStipulation] = useState<any>(null);
    const [showStipulationDropdown, setShowStipulationDropdown] = useState(false);
    const [filteredStipulations, setFilteredStipulations] = useState<any[]>([]);
    const [availableStipulations, setAvailableStipulations] = useState<any[]>([]);

    // Belt state
    const [beltSearch, setBeltSearch] = useState('');
    const [selectedBelt, setSelectedBelt] = useState<any>(null);
    const [showBeltDropdown, setShowBeltDropdown] = useState(false);
    const [filteredBelts, setFilteredBelts] = useState<any[]>([]);

    // Wrestler state (per ogni select)
    const [wrestlerSearches, setWrestlerSearches] = useState<any>({});
    const [selectedWrestlers, setSelectedWrestlers] = useState<any>({});
    const [showWrestlerDropdowns, setShowWrestlerDropdowns] = useState<any>({});
    const [filteredWrestlers, setFilteredWrestlers] = useState<any>({});

    // Form state
    const [isNoContest, setIsNoContest] = useState(false);
    const [winByDq, setWinByDq] = useState(false);
    const [teamWinner, setTeamWinner] = useState<any>(null);
    const [notes, setNotes] = useState('');
    const [importanceFeud, setImportanceFeud] = useState(1);
    const [levelCard, setLevelCard] = useState('');
    const [isIncassoNwo, setIsIncassoNwo] = useState(false);
    const [orderChangeTitle, setOrderChangeTitle] = useState(1);
    const [isNuovoCampione, setIsNuovoCampione] = useState(false);

    // Team structure based on selected type match
    const [teamsStructure, setTeamsStructure] = useState<any[]>([]);
    
    // Carica i dati se non sono disponibili (solo quando la modale è aperta)
    useEffect(() => {
        if ((!typeMatchesList || (typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length === 0)) && onTypeMatchesLoad) {
            onTypeMatchesLoad();
        }
        if ((!beltsList || beltsList.length === 0) && onBeltsLoad) {
            onBeltsLoad();
        }
        if ((!wrestlersList || wrestlersList.length === 0) && onWrestlersLoad) {
            onWrestlersLoad();
        }
    }, [typeMatchesList, onTypeMatchesLoad, beltsList, onBeltsLoad, wrestlersList, onWrestlersLoad]);
    
    // Estrai i tipi dalle chiavi dell'oggetto typeMatchesList
    useEffect(() => {
        if (typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList)) {
            const types = Object.keys(typeMatchesList);
            setFilteredTypeMatchTypes(types);
        } else {
            setFilteredTypeMatchTypes([]);
        }
    }, [typeMatchesList]);
    
    // Filtra i tipi di type match
    useEffect(() => {
        if (!typeMatchesList || typeof typeMatchesList !== 'object' || Array.isArray(typeMatchesList)) {
            setFilteredTypeMatchTypes([]);
            return;
        }
        
        const types = Object.keys(typeMatchesList);
        if (!typeMatchTypeSearch || typeMatchTypeSearch.trim() === '') {
            setFilteredTypeMatchTypes(types);
        } else {
            const searchLower = typeMatchTypeSearch.toLowerCase();
            const filtered = types.filter(type => type.toLowerCase().includes(searchLower));
            setFilteredTypeMatchTypes(filtered);
        }
    }, [typeMatchTypeSearch, typeMatchesList]);
    
    // Quando viene selezionato un tipo, mostra le stipulations disponibili
    useEffect(() => {
        if (selectedTypeMatchType && typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList)) {
            const matches = typeMatchesList[selectedTypeMatchType] || [];
            setAvailableStipulations(matches);
            setFilteredStipulations(matches);
            
        } else {
            setAvailableStipulations([]);
            setFilteredStipulations([]);
        }
        // Resetta la stipulation quando cambia il tipo match
        if (selectedTypeMatchType) {
            // Se il tipo match è cambiato, resetta la stipulation
            // Ma solo se non c'è già una stipulation selezionata (per evitare reset durante il caricamento iniziale)
            if (!selectedStipulation) {
                setSelectedStipulation(null);
                setStipulationSearch('');
                setTeamsStructure([]);
            }
        }
    }, [selectedTypeMatchType, typeMatchesList, selectedStipulation]);
    
    // Quando viene selezionata una stipulation, crea la struttura dei team
    useEffect(() => {
        if (selectedStipulation) {
            // selectedStipulation è già l'oggetto completo con tutte le proprietà
            // Debug: log per vedere la struttura della stipulation
            console.log('=== DEBUG STIPULATION ===');
            console.log('selectedStipulation completo:', JSON.stringify(selectedStipulation, null, 2));
            console.log('Tutte le chiavi:', Object.keys(selectedStipulation));
            console.log('num_teams:', selectedStipulation.num_teams, 'tipo:', typeof selectedStipulation.num_teams);
            console.log('min_num_wrestlers:', selectedStipulation.min_num_wrestlers, 'tipo:', typeof selectedStipulation.min_num_wrestlers);
            console.log('max_num_wrestlers:', selectedStipulation.max_num_wrestlers, 'tipo:', typeof selectedStipulation.max_num_wrestlers);
            
            // Usa nullish coalescing (??) invece di || per gestire correttamente il valore 0
            // e verifica anche se le proprietà esistono con nomi alternativi (camelCase)
            // Converti esplicitamente a numero per assicurarsi che siano numeri
            const numTeamsRaw = selectedStipulation.num_teams ?? selectedStipulation.numTeams ?? 2;
            const minWrestlersRaw = selectedStipulation.min_num_wrestlers ?? selectedStipulation.minNumWrestlers ?? 1;
            const maxWrestlersRaw = selectedStipulation.max_num_wrestlers ?? selectedStipulation.maxNumWrestlers ?? 1;
            
            // Funzione helper per convertire a numero in modo sicuro
            const toNumber = (value: any, defaultValue: any) => {
                if (value === null || value === undefined) return defaultValue;
                if (typeof value === 'number') return value;
                const parsed = parseInt(value, 10);
                return isNaN(parsed) ? defaultValue : parsed;
            };
            
            const numTeams = toNumber(numTeamsRaw, 2);
            const minWrestlers = toNumber(minWrestlersRaw, 1);
            const maxWrestlers = toNumber(maxWrestlersRaw, 1);
            
            console.log('Valori finali - numTeams:', numTeams, 'minWrestlers:', minWrestlers, 'maxWrestlers:', maxWrestlers);
            
            // Warning se le proprietà non sono presenti
            if (!selectedStipulation.num_teams && !selectedStipulation.numTeams) {
                console.warn('ATTENZIONE: num_teams non trovato nella stipulation, uso default 2');
            }
            if (!selectedStipulation.max_num_wrestlers && !selectedStipulation.maxNumWrestlers) {
                console.warn('ATTENZIONE: max_num_wrestlers non trovato nella stipulation, uso default 1');
            }
            console.log('=== FINE DEBUG ===');
            
            // Assicurati che maxWrestlers sia almeno 1
            const finalMaxWrestlers = Math.max(1, maxWrestlers);
            const finalNumTeams = Math.max(1, numTeams);
            
            const teams = [];
            for (let i = 0; i < finalNumTeams; i++) {
                teams.push({
                    teamIndex: i,
                    minWrestlers: Math.max(1, minWrestlers),
                    maxWrestlers: finalMaxWrestlers,
                    wrestlers: []
                });
            }
            setTeamsStructure(teams);
            
            // Reset wrestlers selezionati
            const newSelectedWrestlers = {};
            const newWrestlerSearches = {};
            teams.forEach((team, teamIdx) => {
                for (let w = 0; w < team.maxWrestlers; w++) {
                    const key = `team_${teamIdx}_wrestler_${w}`;
                    newSelectedWrestlers[key] = null;
                    newWrestlerSearches[key] = '';
                }
            });
            setSelectedWrestlers(newSelectedWrestlers);
            setWrestlerSearches(newWrestlerSearches);
        } else {
            setTeamsStructure([]);
        }
    }, [selectedStipulation]);
    
    // Filtra le stipulations
    useEffect(() => {
        if (!availableStipulations || availableStipulations.length === 0) {
            setFilteredStipulations([]);
            return;
        }
        
        if (!stipulationSearch || stipulationSearch.trim() === '') {
            setFilteredStipulations(availableStipulations);
        } else {
            const searchLower = stipulationSearch.toLowerCase();
            const filtered = availableStipulations.filter(stip => 
                stip.name.toLowerCase().includes(searchLower)
            );
            setFilteredStipulations(filtered);
        }
    }, [stipulationSearch, availableStipulations]);
    
    // Filtra le belts
    useEffect(() => {
        if (!beltsList || beltsList.length === 0) {
            setFilteredBelts([]);
            return;
        }
        
        if (!beltSearch || beltSearch.trim() === '') {
            setFilteredBelts(beltsList);
        } else {
            const searchLower = beltSearch.toLowerCase();
            const filtered = beltsList.filter(belt => 
                belt.name.toLowerCase().includes(searchLower)
            );
            setFilteredBelts(filtered);
        }
    }, [beltSearch, beltsList]);
    
    // Popola filteredWrestlers quando cambia teamsStructure o wrestlersList
    useEffect(() => {
        if (!wrestlersList || wrestlersList.length === 0 || teamsStructure.length === 0) {
            setFilteredWrestlers({});
            return;
        }
        
        console.log('Popolamento filteredWrestlers per teamsStructure:', teamsStructure.length, 'teams, wrestlersList:', wrestlersList.length);
        
        // Inizializza filteredWrestlers per tutte le chiavi necessarie
        const newFiltered = {};
        teamsStructure.forEach((team, teamIdx) => {
            for (let w = 0; w < team.maxWrestlers; w++) {
                const key = `team_${teamIdx}_wrestler_${w}`;
                const search = wrestlerSearches[key] || '';
                if (!search || search.trim() === '') {
                    newFiltered[key] = wrestlersList;
                } else {
                    const searchLower = search.toLowerCase();
                    const filtered = wrestlersList.filter(wrestler => 
                        wrestler.name && wrestler.name.toLowerCase().includes(searchLower)
                    );
                    newFiltered[key] = filtered;
                }
            }
        });
        console.log('filteredWrestlers popolato con chiavi:', Object.keys(newFiltered));
        setFilteredWrestlers(newFiltered);
    }, [teamsStructure, wrestlersList, wrestlerSearches]);
    
    
    // Chiudi dropdown quando si clicca fuori
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (typeMatchDropdownRef.current && !typeMatchDropdownRef.current.contains(event.target)) {
                setShowTypeMatchTypeDropdown(false);
            }
            if (stipulationDropdownRef.current && !stipulationDropdownRef.current.contains(event.target)) {
                setShowStipulationDropdown(false);
            }
            if (beltDropdownRef.current && !beltDropdownRef.current.contains(event.target)) {
                setShowBeltDropdown(false);
            }
            Object.keys(wrestlerDropdownRefs.current).forEach(key => {
                if (wrestlerDropdownRefs.current[key] && !wrestlerDropdownRefs.current[key].contains(event.target)) {
                    setShowWrestlerDropdowns(prev => ({ ...prev, [key]: false }));
                }
            });
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    // Funzione per ottenere l'anno dalla data
    const getYearFromDate = (dateValue: any) => {
        if (!dateValue) return '';
        let date;
        if (typeof dateValue === 'number') {
            date = dateValue > 1e12 ? new Date(dateValue) : new Date(dateValue * 1000);
        } else if (typeof dateValue === 'string') {
            if (/^\d+$/.test(dateValue)) {
                const numValue = parseInt(dateValue);
                date = numValue > 1e12 ? new Date(numValue) : new Date(numValue * 1000);
            } else {
                date = new Date(dateValue);
            }
        } else {
            date = new Date(dateValue);
        }
        if (isNaN(date.getTime())) return '';
        return date.getFullYear();
    };
    
    const handleSubmit = async (event: any) => {
        setIsLoadingForm(true);
        setErrorsForm({});
        event.preventDefault();
        
        if (!selectedStipulation) {
            setErrorsForm({ type_match_id: 'Seleziona un tipo di match' });
            setIsLoadingForm(false);
            return;
        }
        
        // Costruisci i team
        const teams = [];
        teamsStructure.forEach((team, teamIndex) => {
            const teamWrestlers = [];
            for (let w = 0; w < team.maxWrestlers; w++) {
                const key = `team_${teamIndex}_wrestler_${w}`;
                const wrestler = selectedWrestlers[key];
                if (wrestler) {
                    teamWrestlers.push(wrestler.id);
                }
            }
            if (teamWrestlers.length > 0) {
                teams.push(teamWrestlers);
            }
        });
        
        if (teams.length === 0) {
            setErrorsForm({ teams: 'Seleziona almeno un wrestler per ogni team' });
            setIsLoadingForm(false);
            return;
        }
        
        const body = {
            ppv_id: ppvSpecific.id,
            type_match_id: selectedStipulation.id,
            belt_id: selectedBelt ? selectedBelt.id : null,
            is_no_contest: isNoContest ? 1 : 0,
            win_by_dq: winByDq ? 1 : 0,
            notes: notes || null,
            importance_feud: importanceFeud,
            level_card: levelCard || null,
            is_incasso_nwo: isIncassoNwo ? 1 : 0,
            order_change_title: orderChangeTitle,
            is_nuovo_campione: isNuovoCampione ? 1 : 0,
            teams: teams,
            team_winner: teamWinner !== null ? parseInt(teamWinner) : null
        };
        
        try {
            // Chiama l'API e controlla lo status HTTP
            const token = localStorage.getItem('token');
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'api/match/v2/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(body),
                credentials: 'include'
            });
            
            const responseData = await response.json();
            
            // Se lo status HTTP non è 200-299, considera la risposta come errore
            if (!response.ok) {
                // Anche se la risposta ha un JSON, se lo status non è OK, è un errore
                setResponseApiCreateMatch(responseData && (responseData.error || responseData.errors)
                    ? responseData
                    : { error: responseData.message || `Errore ${response.status}: ${response.statusText}` });
                setIsLoadingForm(false);
            } else {
                // Status OK: verifica se ci sono errori nel JSON
                if (responseData && (responseData.error || responseData.errors)) {
                    setResponseApiCreateMatch(responseData);
                } else {
                    // Successo: nessun errore
                    setResponseApiCreateMatch(responseData);
                }
            }
        } catch (error) {
            console.error('Errore durante la creazione del match:', error);
            // Gestisci errori di rete o altri errori non gestiti dall'API
            const errorMessage = error?.response?.data?.error || error?.message || 'Si è verificato un errore durante la creazione del match. Riprova.';
            setResponseApiCreateMatch({ error: errorMessage });
            setIsLoadingForm(false);
        }
    };
    
    useEffect(() => {
        if (!isFirstRendering && Object.keys(responseApiCreateMatch).length > 0) {
            // Gestisci errori specifici per campo - PRIORITÀ: se ci sono errori, NON chiamare onMatchCreated
            if (responseApiCreateMatch.errors) {
                setErrorsForm(responseApiCreateMatch.errors);
                setIsLoadingForm(false);
                setMatchCreated(false);
            } 
            // Gestisci errore generale - PRIORITÀ: se c'è un errore, NON chiamare onMatchCreated
            else if (responseApiCreateMatch.error) {
                setErrorsForm({ general: responseApiCreateMatch.error });
                setIsLoadingForm(false);
                setMatchCreated(false);
            } 
            // Successo: SOLO se NON ci sono errori E la risposta ha dati validi
            // Verifica che la risposta abbia almeno un campo che indica successo
            else {
                const hasSuccessIndicator = responseApiCreateMatch.id || 
                                           responseApiCreateMatch.data || 
                                           responseApiCreateMatch.match ||
                                           (Object.keys(responseApiCreateMatch).length > 0 && 
                                            !responseApiCreateMatch.error && 
                                            !responseApiCreateMatch.errors);
                
                if (hasSuccessIndicator && !matchCreated) {
                    setIsLoadingForm(false);
                    setMatchCreated(true);
                    if (onMatchCreated) {
                        onMatchCreated();
                    }
                }
            }
        } else if (isFirstRendering) {
            setIsFirstRendering(false);
        }
    }, [responseApiCreateMatch, onMatchCreated, matchCreated, isFirstRendering]);
    
    const handleCloseModal = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setMatchCreated(false);
        setErrorsForm({});
        setSelectedTypeMatchType(null);
        setSelectedStipulation(null);
        setSelectedBelt(null);
        setSelectedWrestlers({});
        setWrestlerSearches({});
        setTypeMatchTypeSearch('');
        setStipulationSearch('');
        setBeltSearch('');
        setIsNoContest(false);
        setWinByDq(false);
        setTeamWinner(null);
        setNotes('');
        setImportanceFeud(1);
        setLevelCard('');
        setIsIncassoNwo(false);
        setOrderChangeTitle(1);
        setIsNuovoCampione(false);
        setTeamsStructure([]);
        closeModalClick();
    };
    
    const handleTypeMatchTypeSelect = (type: any) => {
        setSelectedTypeMatchType(type);
        // Mostra il tipo selezionato nella search box (puoi personalizzare il formato)
        setTypeMatchTypeSearch(type);
        setShowTypeMatchTypeDropdown(false);
    };
    
    const handleStipulationSelect = (stipulation: any) => {
        setSelectedStipulation(stipulation);
        setStipulationSearch(stipulation.name);
        setShowStipulationDropdown(false);
    };
    
    const handleBeltSelect = (belt: any) => {
        setSelectedBelt(belt);
        setBeltSearch(belt.name);
        setShowBeltDropdown(false);
    };
    
    const handleClearBelt = () => {
        setSelectedBelt(null);
        setBeltSearch('');
    };
    
    const handleWrestlerSelect = (key, wrestler) => {
        setSelectedWrestlers(prev => ({ ...prev, [key]: wrestler }));
        setWrestlerSearches(prev => ({ ...prev, [key]: wrestler.name }));
        setShowWrestlerDropdowns(prev => ({ ...prev, [key]: false }));
    };
    
    const handleClearWrestler = (key: any) => {
        setSelectedWrestlers(prev => ({ ...prev, [key]: null }));
        setWrestlerSearches(prev => ({ ...prev, [key]: '' }));
    };
    
    const handleWrestlerInputFocus = (key: any) => {
        // Assicurati che filteredWrestlers[key] sia popolato quando l'utente apre il dropdown
        if (!filteredWrestlers[key] && wrestlersList && wrestlersList.length > 0) {
            setFilteredWrestlers(prev => ({
                ...prev,
                [key]: wrestlersList
            }));
        }
        setShowWrestlerDropdowns(prev => ({ ...prev, [key]: true }));
    };
    
    return (
        <Container className="create-match-modale-container">
            <ModalDialog className="create-match-modale-dialog">
                <ModalContent className="create-match-modale-content">
                    <form ref={formRef} onSubmit={handleSubmit} className="create-match-modale-form">
                        <ModalHeader className="create-match-modale-header">
                            <ModalHeaderTop className="create-match-modale-header-top">
                                <ModalTitle className="create-match-modale-title">
                                    Inserisci Match
                                </ModalTitle>
                                <CloseButton type="button" aria-label="Close" onClick={handleCloseModal} className="create-match-modale-close-button"></CloseButton>
                            </ModalHeaderTop>
                            <PpvInfo className="create-match-modale-ppv-info">
                                {ppvGeneraleName} {getYearFromDate(ppvSpecific?.date)}
                            </PpvInfo>
                        </ModalHeader>
                        <ModalBody className="create-match-modale-body">
                            {/* Debug info - rimuovere in produzione */}
                            {(!typeMatchesList || (typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length === 0)) && (
                                <FormGroup className="create-match-modale-form-group">
                                    <ErrorText className="create-match-modale-error-text">
                                        Caricamento tipi match in corso... 
                                        {typeMatchesList ? ` (Tipo: ${typeof typeMatchesList}, Keys: ${Object.keys(typeMatchesList || {}).length})` : ' (Nessun dato)'}
                                    </ErrorText>
                                </FormGroup>
                            )}
                            
                            {/* Descrizione Type Match */}
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel className="create-match-modale-label" style={{ fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', fontWeight: 'normal' }}>
                                    Selezionare il tipo match e automaticamente compariranno le varie select per la selezione dei wrestlers
                                </FormLabel>
                            </FormGroup>
                            
                            {/* Select Type Match Type */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="type_match_type" className="create-match-modale-label">Tipo Match *</FormLabel>
                                <DropdownContainer ref={typeMatchDropdownRef}>
                                    <DropdownInput
                                        type="text"
                                        id="type_match_type"
                                        placeholder={typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length > 0 
                                            ? "Cerca tipo match..." 
                                            : "Caricamento in corso..."}
                                        value={typeMatchTypeSearch}
                                        onChange={(e: any) => {
                                            setTypeMatchTypeSearch(e.target.value);
                                            setShowTypeMatchTypeDropdown(true);
                                        }}
                                        onFocus={() => {
                                            if (typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length > 0) {
                                                setShowTypeMatchTypeDropdown(true);
                                            }
                                        }}
                                        disabled={!typeMatchesList || (typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length === 0)}
                                    />
                                    {showTypeMatchTypeDropdown && filteredTypeMatchTypes.length > 0 && (
                                        <DropdownList>
                                            {filteredTypeMatchTypes.map((type: any) => (
                                                <DropdownItem 
                                                    key={type}
                                                    onClick={() => handleTypeMatchTypeSelect(type)}
                                                >
                                                    {type}
                                                </DropdownItem>
                                            ))}
                                        </DropdownList>
                                    )}
                                    {showTypeMatchTypeDropdown && filteredTypeMatchTypes.length === 0 && typeMatchTypeSearch && (
                                        <DropdownList>
                                            <DropdownEmpty>Nessun tipo trovato</DropdownEmpty>
                                        </DropdownList>
                                    )}
                                </DropdownContainer>
                                {errorsForm.type_match_id && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.type_match_id) ? errorsForm.type_match_id[0] : errorsForm.type_match_id}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Select Stipulation */}
                            {selectedTypeMatchType && (
                                <FormGroup className="create-match-modale-form-group">
                                    <FormLabel htmlFor="stipulation" className="create-match-modale-label">Stipulation *</FormLabel>
                                    <DropdownContainer ref={stipulationDropdownRef}>
                                        <DropdownInput
                                            type="text"
                                            id="stipulation"
                                            placeholder={availableStipulations && availableStipulations.length > 0 ? "Cerca stipulation..." : "Caricamento stipulations..."}
                                            value={stipulationSearch}
                                            onChange={(e: any) => {
                                                setStipulationSearch(e.target.value);
                                                setShowStipulationDropdown(true);
                                            }}
                                            onFocus={() => {
                                                if (availableStipulations && availableStipulations.length > 0) {
                                                    setShowStipulationDropdown(true);
                                                }
                                            }}
                                            disabled={!availableStipulations || availableStipulations.length === 0}
                                        />
                                        {showStipulationDropdown && filteredStipulations.length > 0 && (
                                            <DropdownList>
                                                {filteredStipulations.map((stipulation: any) => (
                                                    <DropdownItem 
                                                        key={stipulation.id}
                                                        onClick={() => handleStipulationSelect(stipulation)}
                                                    >
                                                        {stipulation.name}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownList>
                                        )}
                                        {showStipulationDropdown && filteredStipulations.length === 0 && stipulationSearch && (
                                            <DropdownList>
                                                <DropdownEmpty>Nessuna stipulation trovata</DropdownEmpty>
                                            </DropdownList>
                                        )}
                                    </DropdownContainer>
                                    {errorsForm.type_match_id && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.type_match_id) ? errorsForm.type_match_id[0] : errorsForm.type_match_id}</ErrorText>}
                                </FormGroup>
                            )}
                            
                            {/* Select Wrestlers per ogni team */}
                            {teamsStructure.length > 0 && teamsStructure.map((team, teamIndex) => (
                                <TeamSection key={teamIndex} className="create-match-modale-team-section">
                                    <TeamTitle>Team {teamIndex + 1}</TeamTitle>
                                    {Array.from({ length: team.maxWrestlers }).map((_, wrestlerIndex) => {
                                        const key = `team_${teamIndex}_wrestler_${wrestlerIndex}`;
                                        return (
                                            <WrestlerSelectContainer key={wrestlerIndex} ref={el => wrestlerDropdownRefs.current[key] = el}>
                                                <WrestlerSelectLabel>
                                                    Wrestler {wrestlerIndex + 1} {wrestlerIndex < team.minWrestlers ? '*' : ''}
                                                </WrestlerSelectLabel>
                                                <DropdownInput
                                                    type="text"
                                                    placeholder="Cerca wrestler..."
                                                    value={wrestlerSearches[key] || ''}
                                                    onChange={(e: any) => {
                                                        setWrestlerSearches(prev => ({ ...prev, [key]: e.target.value }));
                                                        setShowWrestlerDropdowns(prev => ({ ...prev, [key]: true }));
                                                    }}
                                                    onFocus={() => handleWrestlerInputFocus(key)}
                                                />
                                                {selectedWrestlers[key] && (
                                                    <RemoveFileButton 
                                                        type="button"
                                                        onClick={() => handleClearWrestler(key)}
                                                        style={{ marginTop: '8px' }}
                                                    >
                                                        Rimuovi
                                                    </RemoveFileButton>
                                                )}
                                                {showWrestlerDropdowns[key] && (
                                                    <DropdownList>
                                                        {filteredWrestlers[key] && filteredWrestlers[key].length > 0 ? (
                                                            filteredWrestlers[key].map((wrestler: any) => (
                                                                <DropdownItem 
                                                                    key={wrestler.id}
                                                                    onClick={() => handleWrestlerSelect(key, wrestler)}
                                                                >
                                                                    {wrestler.name}
                                                                </DropdownItem>
                                                            ))
                                                        ) : (
                                                            <DropdownEmpty>
                                                                {!wrestlersList || wrestlersList.length === 0 
                                                                    ? 'Caricamento wrestlers...' 
                                                                    : wrestlerSearches[key] 
                                                                        ? 'Nessun wrestler trovato' 
                                                                        : 'Nessun wrestler disponibile'}
                                                            </DropdownEmpty>
                                                        )}
                                                    </DropdownList>
                                                )}
                                            </WrestlerSelectContainer>
                                        );
                                    })}
                                </TeamSection>
                            ))}
                            
                            {/* Radio No Contest */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel className="create-match-modale-label">È No Contest?</FormLabel>
                                <RadioGroup className="create-match-modale-radio-group">
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_no_contest" 
                                            value="1" 
                                            checked={isNoContest}
                                            onChange={() => setIsNoContest(true)}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_no_contest" 
                                            value="0" 
                                            checked={!isNoContest}
                                            onChange={() => setIsNoContest(false)}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                            </FormGroup>
                            }
                            
                            {/* Select Team Winner */}
                            {teamsStructure.length > 0 && !isNoContest && (
                                <FormGroup className="create-match-modale-form-group">
                                    <FormLabel htmlFor="team_winner" className="create-match-modale-label">Team Vincitore *</FormLabel>
                                    <FormSelect 
                                        id="team_winner"
                                        value={teamWinner || ''}
                                        onChange={(e: any) => setTeamWinner(e.target.value)}
                                        required
                                    >
                                        <option value="">Seleziona team vincitore</option>
                                        {teamsStructure.map((team, index) => {
                                            // Recupera i nomi dei wrestlers per questo team
                                            const teamWrestlers = [];
                                            for (let w = 0; w < team.maxWrestlers; w++) {
                                                const key = `team_${index}_wrestler_${w}`;
                                                const wrestler = selectedWrestlers[key];
                                                if (wrestler && wrestler.name) {
                                                    teamWrestlers.push(wrestler.name);
                                                }
                                            }
                                            const wrestlersText = teamWrestlers.length > 0 
                                                ? ` (${teamWrestlers.join(', ')})` 
                                                : '';
                                            return (
                                                <option key={index} value={index}>
                                                    Team {index + 1}{wrestlersText}
                                                </option>
                                            );
                                        })}
                                    </FormSelect>
                                    {errorsForm.team_winner && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.team_winner) ? errorsForm.team_winner[0] : errorsForm.team_winner}</ErrorText>}
                                </FormGroup>
                            )}
                            
                            {/* Radio Win by DQ */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel className="create-match-modale-label">È finita per No DQ? Selezionare SI anche nel caso in cui: "Wrestler A vince un match titolato ma non c'è stato per X motivo un cambio titolo" Esempio: Paolone sconfigge Morbid per il titolo mondiale, ma a fine match interviene il GM che annulla l'assegnazione della cintura.</FormLabel>
                                <RadioGroup className="create-match-modale-radio-group">
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="win_by_dq" 
                                            value="1" 
                                            checked={winByDq}
                                            onChange={() => setWinByDq(true)}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="win_by_dq" 
                                            value="0" 
                                            checked={!winByDq}
                                            onChange={() => setWinByDq(false)}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                            </FormGroup>
                            }
                            
                            {/* Notes */}
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="notes" className="create-match-modale-label">Note</FormLabel>
                                <FormTextarea 
                                    id="notes" 
                                    name="notes" 
                                    className="create-match-modale-textarea"
                                    value={notes}
                                    onChange={(e: any) => setNotes(e.target.value)}
                                    placeholder="Inserisci note (opzionale)"
                                />
                                {errorsForm.notes && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.notes) ? errorsForm.notes[0] : errorsForm.notes}</ErrorText>}
                            </FormGroup>
                            
                            {/* Importance Feud */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="importance_feud" className="create-match-modale-label">Da 1 a 5 quanto pensi sia importante questo feud?(e la fase del feud) Mettere 5 solamente per match veramente speciali (es: Morbid vs Paolone) *</FormLabel>
                                <FormSelect 
                                    id="importance_feud"
                                    value={importanceFeud}
                                    onChange={(e: any) => setImportanceFeud(parseInt(e.target.value))}
                                    required
                                >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </FormSelect>
                                    {errorsForm.importance_feud && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.importance_feud) ? errorsForm.importance_feud[0] : errorsForm.importance_feud}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Level Card */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="level_card" className="create-match-modale-label">Level Card *</FormLabel>
                                <FormSelect 
                                    id="level_card"
                                    value={levelCard}
                                    onChange={(e: any) => setLevelCard(e.target.value)}
                                    required
                                >
                                    <option value="">Seleziona level card</option>
                                    <option value="Low Card">Low Card</option>
                                    <option value="Mid Card">Mid Card</option>
                                    <option value="High Card">High Card</option>
                                </FormSelect>
                                    {errorsForm.level_card && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.level_card) ? errorsForm.level_card[0] : errorsForm.level_card}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Radio Incasso NWO */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel className="create-match-modale-label">Questo match è l'incasso di un NWO improvviso?</FormLabel>
                                <RadioGroup className="create-match-modale-radio-group">
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_incasso_nwo" 
                                            value="1" 
                                            checked={isIncassoNwo}
                                            onChange={() => setIsIncassoNwo(true)}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_incasso_nwo" 
                                            value="0" 
                                            checked={!isIncassoNwo}
                                            onChange={() => setIsIncassoNwo(false)}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                            </FormGroup>
                            }
                            
                            {/* Order Change Title */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="order_change_title" className="create-match-modale-label">Se match titolato, questa cintura ha CAMBIATO campione già nel corso della serata? Se si, inserire l'ordine di cambio del match. Esempio: Andy Guerrero campione contro Thomas Ross. In questo match vince Ross e lascio 1. Incasso NWO di Morbid con successo. Inserisco 2 perhè è il secondo cambio. Interviene il GM e sancisce subito un match titolato contro Paolone che vince. Inserisco 3 perchè c'è il campo. Se Paolone avesse perso, non c'è bisogno di modificare questo valore</FormLabel>
                                <FormInput 
                                    type="number" 
                                    id="order_change_title" 
                                    name="order_change_title" 
                                    min="1"
                                    value={orderChangeTitle}
                                    onChange={(e: any) => setOrderChangeTitle(parseInt(e.target.value) || 1)}
                                    className="create-match-modale-input"
                                />
                                    {errorsForm.order_change_title && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.order_change_title) ? errorsForm.order_change_title[0] : errorsForm.order_change_title}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Radio Nuovo Campione */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel className="create-match-modale-label">C'è stato un passaggio di titolo in questo match?</FormLabel>
                                <RadioGroup className="create-match-modale-radio-group">
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_nuovo_campione" 
                                            value="1" 
                                            checked={isNuovoCampione}
                                            onChange={() => setIsNuovoCampione(true)}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-match-modale-radio-label">
                                        <input 
                                            type="radio" 
                                            name="is_nuovo_campione" 
                                            value="0" 
                                            checked={!isNuovoCampione}
                                            onChange={() => setIsNuovoCampione(false)}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                                {errorsForm.is_nuovo_campione && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.is_nuovo_campione) ? errorsForm.is_nuovo_campione[0] : errorsForm.is_nuovo_campione}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Select Belt */}
                            {
                            <FormGroup className="create-match-modale-form-group">
                                <FormLabel htmlFor="belt" className="create-match-modale-label">Cintura (opzionale)</FormLabel>
                                <DropdownContainer ref={beltDropdownRef}>
                                    <DropdownInput
                                        type="text"
                                        id="belt"
                                        placeholder="Cerca cintura..."
                                        value={beltSearch}
                                        onChange={(e: any) => {
                                            setBeltSearch(e.target.value);
                                            setShowBeltDropdown(true);
                                        }}
                                        onFocus={() => setShowBeltDropdown(true)}
                                    />
                                    {selectedBelt && (
                                        <RemoveFileButton 
                                            type="button"
                                            onClick={handleClearBelt}
                                            style={{ marginTop: '8px' }}
                                        >
                                            Rimuovi Cintura
                                        </RemoveFileButton>
                                    )}
                                    {showBeltDropdown && filteredBelts.length > 0 && (
                                        <DropdownList>
                                            {filteredBelts.map((belt: any) => (
                                                <DropdownItem 
                                                    key={belt.id}
                                                    onClick={() => handleBeltSelect(belt)}
                                                >
                                                    {belt.name}
                                                </DropdownItem>
                                            ))}
                                        </DropdownList>
                                    )}
                                </DropdownContainer>
                                    {errorsForm.belt_id && <ErrorText className="create-match-modale-error-text">{Array.isArray(errorsForm.belt_id) ? errorsForm.belt_id[0] : errorsForm.belt_id}</ErrorText>}
                            </FormGroup>
                            }
                            
                            {/* Errore generale */}
                            {errorsForm.general && (
                                <GeneralErrorText className="create-match-modale-general-error">
                                    {Array.isArray(errorsForm.general) ? errorsForm.general[0] : errorsForm.general}
                                </GeneralErrorText>
                            )}
                        </ModalBody>
                        <ModalFooter className="create-match-modale-footer">
                            <ButtonSecondary type="button" onClick={handleCloseModal} className="create-match-modale-button-secondary">Chiudi</ButtonSecondary>
                            <ButtonPrimary type="submit" disabled={isLoadingForm || matchCreated} className="create-match-modale-button-primary">
                                {isLoadingForm ? 'Caricamento...' : 'Crea Match'}
                            </ButtonPrimary>
                        </ModalFooter>
                        {isLoadingForm && <StatusMessage className="create-match-modale-status-message">Caricamento..</StatusMessage>}
                        {matchCreated && <SuccessText className="create-match-modale-success-text">
                            Match creato con successo!
                        </SuccessText>}
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
}

export default CreateMatchModale;
